import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {post} from '../../fetch/fetchOptions';
import {SetPasswordPage} from './SetPasswordPage';
import axios from 'axios';
import {useErrorDisplay} from '../../common/useErrorDisplay';
import {LoadingSpinner} from '../../common/LoadingSpinner';
import {setPasswordUrl} from '../../fetch/urls';

export function SetPassword({lsid, locale, details, updateDispatcher}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useErrorDisplay(error);

  const submit = async ({password}) => {
    setLoading(true);
    setError(null);

    async function doPost() {
      try {
        const res = await axios(
          post({
            url: setPasswordUrl(),
            data: {
              lsid,
              password,
            },
          }),
        );
        setLoading(false);
        updateDispatcher(res.data);
      } catch (exception) {
        console.log('Exception when submitting data: ', exception);
        setLoading(false);
        setError(exception);
      }
    }

    await doPost();
  };

  if (loading) {
    return <LoadingSpinner />;
  } else {
    return <SetPasswordPage locale={locale} submit={submit} socialLoginLinks={details.socialLoginLinks} />;
  }
}

SetPassword.propTypes = {
  updateDispatcher: PropTypes.func.isRequired,
  lsid: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  details: PropTypes.object.isRequired,
};
